/* Luceela page helpers (prefix lc): reveal on scroll + scroll to the bundle selector */
(function(){
  function lcScrollToBundle(){
    var t = document.getElementById('lc-bundle');
    if (!t) return false;
    var y = t.getBoundingClientRect().top + window.pageYOffset - 110;
    window.scrollTo({ top: y, behavior: 'smooth' });
    return true;
  }
  window.lcScrollToBundle = lcScrollToBundle;

  document.addEventListener('click', function(e){
    var el = e.target.closest ? e.target.closest('[data-lc-scroll]') : null;
    if (!el) return;
    var tier = parseInt(el.getAttribute('data-lc-tier') || '0', 10);
    if (document.getElementById('lc-bundle')) {
      e.preventDefault();
      if (tier && typeof window.lcSelectTier === 'function') window.lcSelectTier(tier);
      lcScrollToBundle();
    }
  });

  function initReveal(){
    var els = document.querySelectorAll('.lc-reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function(el){ el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function(el){ io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initReveal); else initReveal();
  document.addEventListener('shopify:section:load', initReveal);
})();
